export default __webpack_public_path__ + "static/media/WalkinOn.66e5b48a.svg";